export default __webpack_public_path__ + "static/media/top-bg_01.61a4f4c4.jpeg";